import { useSyncExternalStore } from "react";

// The partnerships a member can open a workspace for. The shell already fetches matches for its
// counters, so it publishes the list here and the workspace page reads it to offer the switch.
const LAST_KEY = "hm_last_workspace";
let workspaces = [];
const listeners = new Set();

const subscribe = (listener) => { listeners.add(listener); return () => listeners.delete(listener); };
const snapshot = () => workspaces;

// The partnership summary carries ids only; the partner's profile comes from the match it grew out of.
export function workspacesFromMatches(response) {
  const matches = response?.matches || [];
  const active = response?.activePartnerships || (response?.activePartnership ? [response.activePartnership] : []);
  return active.map((partnership) => {
    const match = matches.find((item) => item.partnershipId === partnership.id);
    return {
      id: partnership.id,
      matchId: partnership.matchId || match?.id || null,
      pending: Boolean(partnership.pending),
      partner: partnership.partner?.profile || match?.partner?.profile || null,
    };
  });
}

export function setWorkspaces(next) {
  // The shell refreshes every 30 seconds; only a real change should re-render subscribers.
  if (JSON.stringify(next) === JSON.stringify(workspaces)) return;
  workspaces = next;
  listeners.forEach((listener) => listener());
}

export function useWorkspaces() {
  return useSyncExternalStore(subscribe, snapshot, snapshot);
}

export function rememberWorkspace(id) {
  try { localStorage.setItem(LAST_KEY, id); } catch { /* Private browsing: the first workspace is the fallback. */ }
}

// Where the "Workspaces" entry lands: the one you had open last, if it is still active.
export function preferredWorkspace(list) {
  let last = null;
  try { last = localStorage.getItem(LAST_KEY); } catch { /* See rememberWorkspace. */ }
  return list.find((workspace) => workspace.id === last) || list[0] || null;
}

export function partnerFirstName(workspace) {
  return workspace?.partner?.fullName?.split(" ")[0] || "Partner";
}
